import { ShekelSign } from 'src/viewsTypes';
import { DashboardData } from './types';

export const dashboardData: DashboardData = {
  expenses: {
    total: {
      receipts: { total: 79, change: 0.034 },
      expenses: { total: 2420, change: 0.034 },
    },
    dataPoints: [
      { x: 'january', y: 2800 },
      { x: 'february', y: 2300 },
      { x: 'march', y: 2500 },
      { x: 'april', y: 2300 },
      { x: 'may', y: 2500 },
      { x: 'june', y: 2600 },
    ],
    timeSpan: {
      count: 6,
      timeUnit: 'M',
    },
  },
  status: {
    score: 1,
    violatingCount: 0,
    timeSpan: {
      count: 3,
      timeUnit: 'M',
    },
  },
  receipts: {
    total: {
      receipts: { total: 28 },
      expenses: { total: 2391, unit: ShekelSign },
    },
    vendors: [
      {
        vendorId: '0',
        name: 'וולט',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/b/b0/Wolt-app-icon-2019.png',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '1',
        name: 'שופרסל',
        logo: 'https://play-lh.googleusercontent.com/FZdoorzxUpImwSY5Xh8Ou1ZEOTqI_1JqYdgedTrr6fOgPnkdbm-3JveoNG_AmT6v7dg',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '2',
        name: 'Apple',
        logo: 'https://w7.pngwing.com/pngs/684/943/png-transparent-apple-logo-computer-icons-apple-logo-heart-logo-computer-wallpaper-thumbnail.png',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '3',
        name: 'סיבוס',
        logo: 'https://cdn.geektime.co.il/wp-content/uploads/2012/01/primaryImage.png',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
      {
        vendorId: '4',
        name: 'Amazon',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/4/4a/Amazon_icon.svg',
        expenses: { total: 420, unit: ShekelSign },
        receipts: 42,
        timeSpan: {
          count: 3,
          timeUnit: 'd',
        },
      },
    ],
    timeSpan: {
      count: 30,
      timeUnit: 'd',
    },
  },
};
